import React, { Component, Fragment } from 'react';
import { Formik, Form, Field } from 'formik';
import { Button, Grid, Divider, Message, List, Loader, Dimmer, Checkbox } from 'semantic-ui-react'
import DropzoneComponent from 'react-dropzone-component';
import _ from 'underscore';
import { Link } from 'react-router-dom';
import moment from 'moment';

import 'react-datepicker/dist/react-datepicker.css';
import '../../../../../node_modules/react-dropzone-component/styles/filepicker.css';
import '../../../../../node_modules/dropzone/dist/min/dropzone.min.css';

import FormsInputsText from '../../inputs/text/forms_inputs_text';
import FormsInputDate from '../../inputs/date';
import FormsInputDropdown from '../../inputs/dropdown';
import FormsInputDropdownSearch from '../../inputs/dropdownsearch';
// import FormsInputsRadioGroup from '../../inputs/radio';
import FormsInputsRadioGroupDynamic from '../../inputs/radiodynamic';
import FormsInputsDropdownAddition from '../../inputs/dropdownaddition';
import FormsInputsTime from '../../inputs/time';

import OutpatientValidationSchema from './validation';
import { djsConfig } from '../../../../template/DropZoneTemplate';
import CommonUtility from '../../../../utils/CommonUtility'

const yesNoOptions = [
    { text: 'Yes', value: 'Y' },
    { text: 'No', value: 'N'}
];

const paybackOptions = [
    { text: "Employee's Bank Account", value: 'Bank'},
    { text: 'Cheque', value: 'Cheque' },
    { text: "PayNow via NRIC", value: 'PayNow via NRIC'},
    { text: "Reimbursement by Company", value: 'Payroll'},
    { text: "Reimbursement by Insurer", value: 'Insurer'},
];

const paybackOptionBank = [
    { text: "Employee's Bank Account", value: 'Bank'}
];

const prePostOthersOptions = [
    { text: 'Pre / Post Hospitalisation', value: 'Y' },
    { text: 'Others', value: 'N'}
];

var componentConfig = {
    iconFiletypes: ['.jpeg', '.jpg', '.png', '.pdf'],
    showFiletypeIcon: true,
    postUrl: 'no-url'
};
// var djsConfig = {
//     autoProcessQueue: false,
//     addRemoveLinks: true,
// }
// var eventHandlers = { addedfile: (file) => console.log(file) }

// const prepareDynamicDropDownSelection = (list, useValueAsText = false) => {
//     return _.map(list, (item) => {
//         return { text: (useValueAsText === false) ? item.n : item.c , value: item.c };
//     })
// }
const prepareDynamicDropDownSelectionCompany = (list, useValueAsText = false) => {
    const selectedList = list.filter( company => company.memberType.toUpperCase() == "E");

    return _.map(selectedList, (item) => {
        return { text: (useValueAsText === false) ? item.companyName : item.companyId , value: item.companyId };
    })
};

const prepareDynamicDropDownSelectionClaimant = (list, selectedCompany) => {
    const selectedList = list.filter( company => company.companyId === selectedCompany.companyId);
    
    if (selectedList[0]) 
    {
        return selectedList[0].records.map( item => {
            return { text: item.name, value: item.nric }
        })
    } else {
            return []
    }
};

const prepareDynamicDropDownSelectionHospital = (list, useValueAsText = false, useTextAsValue = false) => {
    var sorted = _.sortBy(list, 'n');
    return _.map(sorted, (item) => {
        return { text: (useValueAsText === false) ? item.n : item.c , value: (useTextAsValue === false) ? item.c : item.n };
    })
}

const prepareDynamicDropDownSelection = (list, useValueAsText = false, useTextAsValue = false) => {
    return _.map(list, (item) => {
        return { text: (useValueAsText === false) ? item.n : item.c , value: (useTextAsValue === false) ? item.c : item.n };
    })
}

const prepareBankOrBranchListOptions = (list) => {
    return _.map(list, (item, index) => {
        return { text: item.n, value: item.c, key: index};
    });
}

const prepareRadioSelection = (list) => {
    return _.map(list, (data) => {
        return { label: data.name, value: data.nric };
    })
};

const prepareBenefitGroupSelection = (list) => {
    let data = _.map(list, (item) => {
        return { text: item.g, value: item.g, ...item.ol[0]};
    });

    return data;
}

const prepareBenefitGroupItemSelection = (list) => {
    const data = _.map(list, (item) => {
        return { 
            text: item.n, 
            value: item.id, 
            sd: item.sd, 
            ptc: item.ptc,
            id: item.id
        }; 
    })
    
    return data;
}

class FormsClaimOutpatient extends Component {
    constructor(props) {
        super(props);
        this.refFormik = React.createRef();
    }

    state = {
        files: [],
        error: false,
        errorMessage: null,
        success: false,
        visitDateErrorMessage: null,
        showDiagnosis: null,
        selectedBenefitId: prepareBenefitGroupItemSelection(
            this.props.claimOptions.bl.map(e => e.ol[0])
        )[0].id,
        payNowTerm: false  
    }

    componentDidMount(){
        this._reloadPage();
    }

    componentDidUpdate(prevProps){
        const { filteredByCompany, filteredByVisitDate, filteredByClaimantId } = prevProps
        if(filteredByCompany !== this.props.filteredByCompany || filteredByVisitDate !== this.props.filteredByVisitDate || filteredByClaimantId !== this.props.filteredByClaimantId){
            this._reloadPage()
        }
    }


    _reloadPage(){
        let selectedCompany = this.props.user.companies.filter( company => company.companyId == this.props.filteredByCompany);
        let selectedClaimantId = selectedCompany[0].records.filter( claimant => claimant.nric == this.props.filteredByClaimantId);
        let selectedVisitDate = this.props.filteredByVisitDate ? moment(this.props.filteredByVisitDate).format('DD/MM/YYYY') : moment().format('DD/MM/YYYY');

        this.props.getClaimOptionsRequest()
        this.props.getEclaimOptionsPageAction(this.props.user.accessToken, selectedVisitDate, this.props.filteredByCompany, selectedClaimantId[0].uuid, (result, error) => {
            if(error){
                this.setState({
                    visitDateErrorMessage: error.errorMessage
                })
            } 
            if(result){
                this.setState({
                    visitDateErrorMessage: null
                })

                let { bl } = result.data.claimoptions.outpatientClaimConfig;
                let benefitTypeOptions = bl ? prepareBenefitGroupSelection(bl) : '';
                // this.refFormik.current.setFieldValue('benefitGroupItem', bl ? prepareBenefitGroupItemSelection((_.find(bl, (benefitType) => benefitType.g === benefitTypeOptions[0].value)).ol)[0].value : '');
                // this.refFormik.current.setFieldValue('benefitGroup', bl ? benefitTypeOptions[0].value : "");
                if (result){
                    if (this.props.filteredByVisitDate){
                        let { bl } = result.data.claimoptions.outpatientClaimConfig;

                        let benefitTypeOptions = prepareBenefitGroupSelection(bl);

                        this.refFormik.current.setFieldValue('benefitGroupItem', prepareBenefitGroupItemSelection((_.find(bl, (benefitType) => benefitType.g === benefitTypeOptions[0].value)).ol)[0].value);
                        this.refFormik.current.setFieldValue('benefitGroup', benefitTypeOptions[0].value);
                        this.refFormik.current.setFieldValue('showDiagnosis', bl[0].ol[0].sd);  

                    }
                }
            }
        })
    }

    updateFileTest(file, is_invoice_receipt = false) {
        if (is_invoice_receipt) {
            file.upload.is_invoice_receipt = true;
        }

        this.setState({files: [...this.state.files, file]});
    }
    
    removeFile(file) { 
        this.setState({
            files: this.state.files.filter(f => f !== file),
            error:false,
            errorMessage:''});
    }
    renderClaimSubmissionResult() {
        if (this.state.success === true) {
            return (
                <Message positive>
                    <Message.Header>Claims Created Successfully!</Message.Header>
                    <p>
                        <Link to="/app/claimrecords">
                            Click here to view the claims now!
                        </Link>
                    </p>
                </Message>
            );
        }
        if (this.state.error === true) {
            return (
                <Message negative>
                    <Message.Header>We're sorry - there was an issue with the claim</Message.Header>
                    <p>
                        { this.state.errorMessage }
                    </p>
                </Message>
            );
        }
    }
    checkAttachmentFile() {
        if (this.state.files.find( (file) => file.size >= 5242880)) {
            return (
                <Message negative>
                    <p>
                        { 'The attachment has exceeded the maximum limit of 5MB. Kindly resize and upload the document again.' }
                    </p>
                </Message>
            );
        }
    }

    checkVisitDate() {
        if (this.state.visitDateErrorMessage) {
            return (
                <Message negative>
                    <p>
                        {this.state.visitDateErrorMessage}
                    </p>
                </Message>
            );
        }
    }

    handlebenefitGroupItem(value){ 
        let { bl } = this.props.claimOptions;   
        
        bl[0].ol.forEach(option=>{  
            if (option.id === value){  
                this.setState({
                    showDiagnosis : option.sd
                  }
                )
            }
        })

        this.setState({ selectedBenefitId: value });
    }

    // Checking other document set mandatory or not
    // return true if optional, false if mandatory
    _checkOtherDocumentOptional() {
        const benefitMenuList = prepareBenefitGroupSelection(this.props.claimOptions.bl);

        const selectedIndex = benefitMenuList.findIndex(
            e => e.id == this.state.selectedBenefitId
        );

        if (selectedIndex == -1) return true;

        const selectedItem = benefitMenuList[selectedIndex];

        // Checking if supportingVisitCode configuration
        // already exist if no aborting proccess
        if (!this.props) return true;
        if (!this.props.configBenefit) return true;
        if (!this.props.configBenefit.supportingVisitCode) return true;
        if (!selectedItem) return true;
        if (!selectedItem.ptc) return true;
        
        const supportingVisitTypes = this.props
            .configBenefit
            .supportingVisitCode;

        const visitTypeCode = selectedItem.ptc;

        
        if (supportingVisitTypes.includes(visitTypeCode)) {
            return false;
        }

        return true;
    }

    handleAgreeChange = () => {
        this.setState({ payNowTerm: !this.state.payNowTerm })
    }

    render() {
        let { dl, bl, cl } = this.props.claimOptions;  
        const { hl, bbl, paymentConfig } = this.props.inpatientClaimOptions;
        const bankList = this.props.inpatientClaimOptions.bl;
        const { bankDetail, nric, costCenterName} = this.props.user;
        const benefitTypeOptions = prepareBenefitGroupSelection(bl);
        const diagnosisList = prepareDynamicDropDownSelection(dl, false, true)
        const typeOfVisits = bl ? prepareBenefitGroupItemSelection((_.find(bl, (benefitType) => benefitType.g === benefitTypeOptions[0].value)).ol) : ''
        // console.log('typeOfVisits', typeOfVisits);
        // var _paymentMethod = (paymentConfig && paymentConfig.defaults) ? paymentConfig.defaults.paymentMethod : 'Bank'
        // var _accountNo = (paymentConfig && paymentConfig.autoFillBankDetails === true) ? bankDetail.accountNo : ''
        // if (_accountNo === '') {
        //     _paymentMethod = 'Cheque'
        // }

        const minTime = new Date();
        minTime.setHours(8,30,0);
        const maxTime = new Date();
        maxTime.setHours(20,30,0);

        // app launch config
        const appLaunchConfig = this.props.appLaunchConfig
        const configBenefit = this.props.configBenefit

        let paymentOpions = [];
        const config = configBenefit.featuresConfig;
        const giroOnly = config.giroOnly;
        const cheque = config.chequeOnly;
        const payNow =  config.payNowOnly;
        const payrollOnly =  config.payrollOnly;
        const allowEclaimPaymentByInsurer =  config.allowEclaimPaymentByInsurer;

        console.log('props--',this.props)
        console.log('state---',this.state)
        //hide Cheque option for following conditions
        if (appLaunchConfig.appLaunchConfig && appLaunchConfig.appLaunchConfig.moh_company_code && (configBenefit.benefit.companyCode.toLowerCase() === appLaunchConfig.appLaunchConfig.moh_company_code.toLowerCase()
            ||
            configBenefit.benefit.companyCode.toLowerCase() === appLaunchConfig.appLaunchConfig.smu_company_local_code.toLowerCase()
            ||
            (configBenefit.benefit.companyCode.toLowerCase() === appLaunchConfig.appLaunchConfig.smu_company_international_code.toLowerCase()
              &&
              !appLaunchConfig.appLaunchConfig.smu_program_code.includes(costCenterName.trim().toLowerCase())))
            )
            {
                if (giroOnly) paymentOpions.push(paybackOptions[0])
                if (payNow) paymentOpions.push(paybackOptions[2])
                if (payrollOnly) paymentOpions.push(paybackOptions[3])
                if (allowEclaimPaymentByInsurer) paymentOpions.push(paybackOptions[4])
            }
        else {

            if (giroOnly) paymentOpions.push(paybackOptions[0])
            if (cheque) paymentOpions.push(paybackOptions[1])
            if (payNow) paymentOpions.push(paybackOptions[2])
            if (payrollOnly) paymentOpions.push(paybackOptions[3])
            if (allowEclaimPaymentByInsurer) paymentOpions.push(paybackOptions[4])
        }
            // default payment options
            var _paybackOptions = paymentOpions
            // set default from api if in option
            var isInOption = _paybackOptions.find(item => item.value === paymentConfig.defaults.paymentMethod)
            var _paymentMethod = isInOption ? paymentConfig.defaults.paymentMethod : _paybackOptions[0].value
            console.log('_paymentMethod',_paymentMethod)
            
        return (
            <div>
                {
                    this.state.success
                    &&
                    <Message positive>
                        <p>
                            Claim number {this.props.currentClaimData.transactionNo } registered. Your claim will be processed within 14 working days.
                        </p>
                        <p>
                            Please tap on <span><Link to={`/app/askjoey?type=outclaim&id=${this.props.currentClaimData.transactionNo}`}>Ask Joey</Link></span> if you have any questions on the claim.
                        </p>
                        <p>
                            <Link to="/app/claimrecords">
                                <Button>
                                    Back to eClaims
                                </Button>
                            </Link>
                        </p>
                    </Message>
                }
                {
                <Dimmer active={this.props.isLoaded} inverted top >
                    <Loader />
                </Dimmer>
                }
                {
                    !this.state.success
                    &&
                    <Formik
                        ref ={this.refFormik}
                        initialValues={{
                            companyId: this.props.user.companies[0].companyId,
                            benefitGroup: bl ? benefitTypeOptions[0].value : "",
                            benefitGroupItem: bl ? prepareBenefitGroupItemSelection((_.find(bl, (benefitType) => benefitType.g === benefitTypeOptions[0].value)).ol)[0].value : "",
                            claimantId: this.props.user.companies[0].records[0].nric,
                            prePostHospitalisation: 'Y',
                            providerName: '',
                            visitDate: moment(),
                            admissionDate: moment(),
                            receiptNo: '',
                            diagnosisText: '',
                            diagnosisCode: '',
                            diagnosisTextFromMember: '',
                            currency: 'SGD',
                            amount: '',
                            empSubRemarks: '',
                            uploadAttachments: '',
                            // benefitId: '',

                            accidentRelated: 'N',
                            workRelated: 'N',
                            accidentDate: moment(),
                            accidentTime: moment(),
                            accidentDetails: '',
                            placeOfAccident: '',
                            accidentClaimableFromCompany: 'N',
                            claimingFromOtherInsurer: 'N',
                            claimingFromOtherInsurerName: '',
                            claimReferenceNo: '',

                            // 'payee',
                            paymentMethod: _paymentMethod,
                            bankName: (paymentConfig && paymentConfig.autoFillBankDetails === true) ? bankDetail.bankName : '',
                            bankNo: (paymentConfig && paymentConfig.autoFillBankDetails === true) ? bankDetail.bankNo : '',
                            branchNo: (paymentConfig && paymentConfig.autoFillBankDetails === true) ? bankDetail.branchNo : '',
                            accountNo: (paymentConfig && paymentConfig.autoFillBankDetails === true) ? bankDetail.accountNo : '',
                            showDiagnosis: bl ?prepareBenefitGroupItemSelection((_.find(bl, (benefitType) => benefitType.g === benefitTypeOptions[0].value)).ol)[0].sd:'',
                            // 'updateBankInfo',
                            // 'submittedBy',
                            includeGST: 'N',
                            gstAmount: '',
                            nric: CommonUtility.maskString(nric, {unmaskedPattern:"4"})
                        }}
                        validateOnChange={false}
                        validateOnBlur={false}
                        validationSchema={OutpatientValidationSchema}
                        validate={(values) => {
                            // Additional Validation (if any)
                            let error = {};

                            const isOtherDocumentOptional = this._checkOtherDocumentOptional();

                            if (!isOtherDocumentOptional && this.state.files.findIndex(e => 
                                e.upload && !e.upload.is_invoice_receipt) == -1) {
                                
                                error.uploadAttachments = 'This field is required.';
                            }

                            if (this.state.files.findIndex(e => 
                                e.upload && e.upload.is_invoice_receipt) == -1) {
                                
                                error.uploadAttachmentsInv = 'This field is required.';
                            }

                            // if (this.state.files.length > 100) {
                            //     error.uploadAttachments = 'Only a maximum of 100 files can be uploaded';
                            // }

                            if (this.state.files.find( (file) => file.size >= 5242880 )) {
                                error.maxFileSize = 'The attachment has exceeded the maximum limit of 5MB. Kindly resize and upload the document again.';
                            }

                            if (this.state.visitDateErrorMessage) {
                                error.visitDate = this.state.visitDateErrorMessage
                            }

                            if (values['includeGST'] == 'Y') {
                                if (!values['gstAmount']){
                                    error.gstAmount = 'GST Amount is required.'
                                }
                                if (values['gstAmount'] <= 0){
                                    error.gstAmount = 'GST Amount must be more than zero'
                                }
                                if (values['amount'] && values['gstAmount'] && Number(values['gstAmount']) >= Number(values['amount'])) {
                                    error.gstAmount = 'GST amount must not higher and equal than amount'
                                }
                            }
                            if (values.paymentMethod === "PayNow via NRIC" && !this.state.payNowTerm){
                                error.payNowTermUncheck = "Missing information. Please review and check."
                            }

                            return error;
                        }}
                        onSubmit={(values, actions) => {
                            // console.log('values', values, actions);
                            // console.log('typeOfVisits', typeOfVisits);
                            // var selectedBenefit = _.find(typeOfVisits, (item) => { return item.value === values.benefitGroupItem }).text
                            // console.log('selectedBenefit', selectedBenefit);

                            // Prepare Data To Submit
                            // 0 - Create a Copy of current "values" object 
                            let data = Object.assign({}, _.omit(values,["showDiagnosis"]));

                            // 1 - Convert Visit Date to (DD/MM/YYYY) format
                            data.visitDate = moment(data.visitDate).format('DD/MM/YYYY');
                            // data.admissionDate = moment(data.admissionDate).format('DD/MM/YYYY');
                            // 1 - Combine and omit fields "accidentDate", "accidentTime" into "accidentDateTime" (DD/MM/YYYY HH:mm)
                            data.accidentDateTime = `${moment(data.accidentDate).format('DD/MM/YYYY')} ${moment(data.accidentTime).format('HH:mm')}`
                            data = _.omit(data, ["accidentDate", "accidentTime"]);
                            // 2 - Copy field "benefitGroupItem" as "benefitId"
                            data.benefitId = data.benefitGroupItem;
                            data.benefitName = _.find(typeOfVisits, (item) => { return item.value === values.benefitGroupItem }).text
                            // 2 - Omit field "benefitGroup", "benefitGroupItem"
                            data = _.omit(data, ['benefitGroup', 'benefitGroupItem']);
                            // 3 - If paymentMethod = 'Cheque', omit fields "bankNo", "branchNo", "accountNo"
                            if (data.paymentMethod === 'Cheque') { data = _.omit(data, ["bankName", "bankNo", "branchNo", "accountNo"]); }
                            // 4 - If accidentRelated = 'N', omit fields "accidentDateTime", "workRelated", "accidentDetails"
                            if (data.accidentRelated === 'N') { data = _.omit(data, ["accidentDateTime", "workRelated", "accidentDetails"]); }
                            // 5 - If claimingFromOtherInsurer = 'N', omit fields "claimingFromOtherInsurerName"
                            if (data.claimingFromOtherInsurer === 'N') { data = _.omit(data, ["claimingFromOtherInsurerName"]); }

                            var diagnosis = dl.find(diagnosis => {
                                return diagnosis.n === data.diagnosisText
                            })
                            var benefitTest = dl.find(diagnosis => {
                                return diagnosis.n === data.diagnosisText
                            })
                            console.log("check diagnosis", )
                            if (typeof diagnosis === "undefined") {
                                data.diagnosisTextFromMember = data.diagnosisText
                            }
                            else {
                                data.diagnosisCode = diagnosis.c
                                data.diagnosisName = data.diagnosisText
                            }

                            if (_.find(typeOfVisits, (item) => { return item.value === values.benefitGroupItem }).text === "Pre / Post Hospitalisation") {
                                data.prePostHospitalisation = 'Y'
                                data.admissionDate = moment(data.admissionDate).format('DD/MM/YYYY');
                            }
                            else {
                                data.prePostHospitalisation = 'N'
                                data = _.omit(data, ['admissionDate']);
                            }

                            // Submit Data to Action Handler
                            // console.log('data', data);
                            if (data.includeGST === 'N') { data.gstAmount = '0' }
                            if (data.includeGST === 'N') { data.includeGST = false }
                            if (data.includeGST === 'Y') { data.includeGST = true }
                            
                            if (this.state.files && this.state.files.length) {
                                data.attachmentDetails = [];
                                
                                data.attachmentDetails = this.state.files.map(e => {
                                    return e.upload.is_invoice_receipt ? 'INV/RCP' : 'DOC'
                                })
                            }

                            this.props.updateCompletedClaimData({
                                data,
                                attachments: this.state.files,
                                accessToken: this.props.user.accessToken
                            });
                        }}
                        render={({
                            values,
                            errors,
                            status,
                            touched,
                            handleBlur,
                            handleChange,
                            handleSubmit,
                            isSubmitting,
                        }) => (
                            <Form style={{paddingBottom: 20}}>
                                <Grid container columns={2}>
                                    <Grid.Column width={16}>
                                        <Message warning>
                                            <Message.Header>IMPORTANT</Message.Header>
                                            <p>
                                                Please read these instructions carefully before uploading the documents.
                                            </p>
                                            <List as='ol'>
                                                <List.Item as='li'>
                                                    Please scan, upload original bills and receipts, original bills and receipts must show
                                                    <List.Item as='ol'>
                                                        <List.Item as='li' value='-'>
                                                            claimant’s name;
                                                        </List.Item>
                                                        <List.Item as='li' value='-'>
                                                            date of treatment;
                                                        </List.Item>
                                                        <List.Item as='li' value='-'>
                                                            diagnosis;
                                                        </List.Item>
                                                        <List.Item as='li' value='-'>
                                                            the attending physician’s stamp and signature.
                                                        </List.Item>
                                                        </List.Item>
                                                    </List.Item>
                                                <List.Item as='li'>
                                                    Claims for Specialist Outpatient Treatment or X-rays/Laboratory tests must include copy of General Practitioner (GP)’s referral letter for the first consultation.<br/><br/>
                                                    Visits to the specialist which are more than 1 year apart require a new referral letter from a GP. (Not applicable to dental claim).
                                                </List.Item>
                                                <List.Item as='li'>
                                                    Claims for purchase of drugs must include a copy of the attending doctor’s prescription (Not applicable to dental claim).
                                                </List.Item>
                                            </List>
                                        </Message>
                                    </Grid.Column>
                                    {/* ##YIN - commented */}
                                    {/*
                                        <Grid.Column width={16}>
                                            <Divider horizontal>
                                                Benefit Type Information
                                            </Divider>
                                        </Grid.Column>
                                        <Grid.Column>
                                            <Field
                                                name="benefitGroup"
                                                options={benefitTypeOptions}
                                                label="Type of Benefit"
                                                secondaryLabel="Select the type of benefit"
                                                component={FormsInputDropdown}
                                            />
                                        </Grid.Column>
                                        <Grid.Column>
                                            <Field
                                                name="benefitGroupItem"
                                                options={prepareBenefitGroupItemSelection((_.find(bl, (benefitType) => benefitType.g === values.benefitGroup)).ol)}
                                                label="Benefit Option"
                                                secondaryLabel="Select the benefit option"
                                                component={FormsInputDropdown}
                                            />
                                        </Grid.Column>
                                    */}
                                    <Grid.Column width={16}>
                                        <Divider horizontal>
                                            Claim Information
                                        </Divider>
                                    </Grid.Column>
                                    {/* <Grid.Column width={16}>
                                        <Field
                                            name="claimantId"
                                            label="Claimant"
                                            component={FormsInputsRadioGroupDynamic}
                                            secondaryLabel=""
                                            choices={prepareRadioSelection(this.props.user.records)}
                                        />
                                    </Grid.Column> */}
                                    {this.props.user.companies.length > 1 &&
                                    <Grid.Column>
                                        <Field
                                            name="companyId"
                                            label="Select Company"
                                            secondaryLabel=""
                                            options={prepareDynamicDropDownSelectionCompany(this.props.user.companies)}
                                            component={FormsInputDropdown}
                                        />
                                    </Grid.Column>}
                                    <Grid.Column>
                                        <Field
                                            name="claimantId"
                                            label="Select Claimant"
                                            secondaryLabel=""
                                            options={prepareDynamicDropDownSelectionClaimant(this.props.user.companies, _.pick(values,['companyId']))}
                                            component={FormsInputDropdown}
                                        />
                                    </Grid.Column>
                                    <Grid.Column>
                                        {/*##YIN // TODO:  - to call API once visit date is selected */}
                                        <Field
                                            name="visitDate"
                                            component={FormsInputDate}
                                            label="Visit Date"
                                            secondaryLabel=""
                                            maxDate={moment()}
                                        />
                                        {this.checkVisitDate()}
                                    </Grid.Column>
                                    <Grid.Column>
                                        <Field
                                            name="benefitGroupItem" 
                                            options={bl && _.find(
                                                bl, (benefitType) => benefitType.g === values.benefitGroup
                                            ) ? prepareBenefitGroupItemSelection(
                                                (_.find(bl, (benefitType) => benefitType.g === values.benefitGroup)).ol
                                            ) 
                                            : prepareBenefitGroupItemSelection(
                                                (_.find(bl, (benefitType) => benefitType.g)).ol
                                            )}

                                            // options={ prepareBenefitGroupItemSelection(
                                            //     (_.map(bl, (benefitType) => benefitType.ol[0]))
                                            // ) }
                                            label="Type of Visit"
                                            secondaryLabel=""
                                            component={FormsInputDropdown}
                                            onChange={(value)=>this.handlebenefitGroupItem(value)}

                                        />
                                        {/*##YIN*/}
                                        {/*
                                            <Field
                                                name="prePostHospitalisation"
                                                options={prePostOthersOptions}
                                                label="Type of Visit"
                                                secondaryLabel="Is your visit a pre / post hospitalisation or others"
                                                component={FormsInputDropdown}
                                            />
                                        */}
                                    </Grid.Column>
                                    <Grid.Column>
                                        <Field
                                            name="providerName"
                                            label="Clinic/Provider Name"
                                            options={prepareDynamicDropDownSelectionHospital(hl, false, true)}
                                            component={FormsInputsDropdownAddition}
                                            secondaryLabel=""
                                        />
                                        {/*#YIN // TODO: - to revisit and read the provider label from TW's API */}
                                        {/*
                                            <Field
                                                name="providerName"
                                                label={(_.find((_.find(bl, (benefitType) => benefitType.g === values.benefitGroup).ol), (item) => item.id === values.benefitGroupItem)).pt}
                                                component={FormsInputsText}
                                                secondaryLabel="Input the name of provider that you have visited"
                                            />
                                        */}
                                    </Grid.Column>
                                    {values.benefitGroupItem && typeOfVisits && _.find(typeOfVisits, (item) => { return item.value === values.benefitGroupItem }) && (_.find(typeOfVisits, (item) => { return item.value === values.benefitGroupItem }).text === "Pre / Post Hospitalisation") && (
                                            <Grid.Column>
                                                <Field
                                                    name="admissionDate"
                                                    component={FormsInputDate}
                                                    label="Admission Date"
                                                    secondaryLabel=""
                                                />
                                            </Grid.Column>
                                        )
                                    }
                                    <Grid.Column>
                                        <Field
                                            name="receiptNo"
                                            label="Receipt/Invoice Number"
                                            component={FormsInputsText}
                                            secondaryLabel=""
                                        />
                                    </Grid.Column> 
                                    {values.showDiagnosis && <Grid.Column width={16}>
                                    <Field
                                        name="diagnosisText"
                                        options={prepareDynamicDropDownSelection(dl, false, true)}
                                        label="Diagnosis / Medical Condition"
                                        secondaryLabel=""
                                        component={FormsInputsDropdownAddition}
                                        // onChange={handleChange}
                                    />
                                </Grid.Column> }  

                                    <Grid.Column>
                                        <Field
                                            name="currency"
                                            options={prepareDynamicDropDownSelection(cl, true)}
                                            label="Currency"
                                            secondaryLabel=""
                                            component={FormsInputDropdown}
                                        />
                                    </Grid.Column>
                                    <Grid.Column>
                                        <Field
                                            name="amount"
                                            label="Amount"
                                            component={FormsInputsText}
                                            secondaryLabel=""
                                        />
                                    </Grid.Column>
                                    <Grid.Column width={16}>
                                        <Field
                                            name="includeGST"
                                            options={yesNoOptions}
                                            label="Does the amount above include GST?"
                                            secondaryLabel=""
                                            component={FormsInputDropdown}
                                        />
                                    </Grid.Column>
                                    {
                                        (values.includeGST === "Y") && (
                                            <Grid.Column width={16}>
                                                <Field
                                                    name="gstAmount"
                                                    label="Please insert the amount of GST"
                                                    component={FormsInputsText}
                                                    secondaryLabel=""
                                                />
                                           
                                            </Grid.Column>
                                        )
                                    }
                                    <Grid.Column width={16}>
                                        <Field
                                            name="empSubRemarks"
                                            label="Remarks (Optional)"
                                            component={FormsInputsText}
                                            secondaryLabel=""
                                        />
                                    </Grid.Column>

                                    <Grid.Column width={16}>
                                        <Divider horizontal>
                                            Accident Information
                                        </Divider>
                                    </Grid.Column>

                                    <Grid.Column width={16}>
                                        <Field
                                            name="accidentRelated"
                                            options={yesNoOptions}
                                            label="Is this claim for treatment of injury as a result of an accident?"
                                            secondaryLabel=""
                                            component={FormsInputDropdown}
                                        />
                                    </Grid.Column>
                                    {
                                        (values.accidentRelated === "Y") && (
                                            <Grid.Column width={16}>
                                                <Field
                                                    name="accidentDate"
                                                    component={FormsInputDate}
                                                    label="Date of Accident"
                                                    secondaryLabel=""
                                                    maxDate={values.visitDate}
                                                />
                                            </Grid.Column>
                                        )
                                    }
                                    {
                                        (values.accidentRelated === "Y") && (
                                            <Grid.Column width={16}>
                                                <Field
                                                    name="accidentTime"
                                                    label="Time of Accident"
                                                    component={FormsInputsTime}
                                                    secondaryLabel=""
                                                    minTime={ moment().startOf('day') }
                                                    maxTime={ moment() }
                                                />
                                            </Grid.Column>
                                        )
                                    }
                                    {
                                        (values.accidentRelated === "Y") && (
                                            <Grid.Column width={16}>
                                                <Field
                                                    name="placeOfAccident"
                                                    label="Place of Accident"
                                                    component={FormsInputsText}
                                                    secondaryLabel=""
                                                />
                                            </Grid.Column>
                                        )
                                    }
                                    {
                                        (values.accidentRelated === "Y") && (
                                            <Grid.Column>
                                                <Field
                                                    name="workRelated"
                                                    options={yesNoOptions}
                                                    label="Is it work related?"
                                                    secondaryLabel=""
                                                    component={FormsInputDropdown}
                                                />
                                            </Grid.Column>
                                        )
                                    }
                                    {
                                        (values.accidentRelated === "Y") && (
                                            <Grid.Column width={16}>
                                                <Field
                                                    name="accidentDetails"
                                                    label="Give details of how the injury was caused by the accident. (Please enclose a copy of the police report, if any)"
                                                    component={FormsInputsText}
                                                    secondaryLabel=""
                                                />
                                            </Grid.Column>
                                        )
                                    }
                                    {
                                        (values.accidentRelated === "Y")
                                        &&
                                        (values.workRelated === "Y")
                                        &&
                                        (
                                            <Grid.Column width={16}>
                                                <Field
                                                    name="accidentClaimableFromCompany"
                                                    options={yesNoOptions}
                                                    label="Are these medical expenses claimable under your company's work injury compensation act policy?"
                                                    secondaryLabel=""
                                                    component={FormsInputDropdown}
                                                />
                                            </Grid.Column>
                                        )
                                    }
                                    <Grid.Column width={16}>
                                        <Field
                                            name="claimingFromOtherInsurer"
                                            options={yesNoOptions}
                                            label="Have you claimed or do you intend to claim from any insurer, other employer or any other parties for reimbursement of your medical bills? If yes, please state the party that you are claiming from and submit a copy of the settlement letter or payment voucher from the other party."
                                            secondaryLabel=""
                                            component={FormsInputDropdown}
                                        />
                                    </Grid.Column>
                                    {
                                        (values.claimingFromOtherInsurer === "Y") && (
                                            <Grid.Column width={16}>
                                                <Field
                                                    name="claimingFromOtherInsurerName"
                                                    label="Name of the party that you are claiming from"
                                                    component={FormsInputsText}
                                                    secondaryLabel=""
                                                />
                                            </Grid.Column>
                                        )
                                    }

                                    <Grid.Column width={16}>
                                        <Divider horizontal>
                                            Reimbursement Information
                                        </Divider>
                                    </Grid.Column>

                                    <Grid.Column width={16}>
                                        <Field
                                            name="paymentMethod"
                                            options={_paybackOptions}
                                            label="Payment to be made by"
                                            secondaryLabel=""
                                            component={FormsInputDropdown}
                                            disabled={!paymentConfig.updateBankInfo}
                                        />
                                    </Grid.Column>

                                    {
                                        (values.paymentMethod === "Bank") &&
                                        (
                                            <Grid.Column width={16}>
                                                <Message>
                                                    <p>
                                                        The following bank account in your Profile must be your bank account. If you provide us with an inaccurate bank account number, we will not be liable for any losses incurred by you.
                                                    </p>
                                                </Message>
                                            </Grid.Column>
                                        )
                                    }

                                    {
                                          (values.paymentMethod == "Bank") &&
                                          (
                                              <Grid.Column>
                                                  <Field
                                                      name="bankName"
                                                      label="Bank Name"
                                                      component={FormsInputsText}
                                                      secondaryLabel=""
                                                      disabled={true}
                                                  />
                                              </Grid.Column>
                                          )
                                      }
                                      {
                                          (values.paymentMethod == "Bank") &&
                                          (
                                              <Grid.Column>
                                                  <Field
                                                      name="branchNo"
                                                      label="Bank Branch"
                                                      component={FormsInputsText}
                                                      secondaryLabel=""
                                                      disabled={true}
                                                  />
                                              </Grid.Column>
                                          )
                                      }
                                    {
                                        (values.paymentMethod === "Bank") &&
                                        (
                                            <Grid.Column>
                                                <Field
                                                    name="accountNo"
                                                    label="Bank Account Number"
                                                    component={FormsInputsText}
                                                    secondaryLabel=""
                                                    disabled={true}
                                                />
                                            </Grid.Column>
                                        )
                                    }
                                    {
                                        (values.paymentMethod === "PayNow via NRIC") &&
                                        (
                                            <Grid.Column>
                                                <Field
                                                    name="nric"
                                                    label="NRIC"
                                                    component={FormsInputsText}
                                                    secondaryLabel=""
                                                    disabled={true}
                                                />
                                            </Grid.Column>
                                        )
                                    }
                                
                                    {
                                    (values.paymentMethod === "PayNow via NRIC") &&
                                        (
                                            <Grid.Column width={16}>
                                                 <Message>
                                                    <p>
                                                    In order for reimbursement transactions to be successful, kindly acknowledge that you have registered for PayNow via NRIC. Otherwise, please select another payment mode to avoid unintended delays in reimbursement.
                                                    </p>
                                                </Message>
                                                <Checkbox
                                                    label='I confirmed that I have registered for PayNow via NRIC.'
                                                    onChange={this.handleAgreeChange}
                                                    checked={this.state.payNowTerm}
                                                />
                                                {
                                                (errors['payNowTermUncheck']) &&
                                                    (
                                                        <Message negative>
                                                            {errors['payNowTermUncheck']}
                                                        </Message>
                                                    )
                                                }
                                        </Grid.Column>
                                        )
                                    }


                                    <Grid.Column width={16}>
                                        <Divider horizontal>
                                            All Required Documents, Documentary Proofs, Medical Reports
                                        </Divider>
                                    </Grid.Column>

                                    <Grid.Column width={16}>
                                        <Message warning>
                                            <p>
                                                Please prepare scanned copy of your supporting documents for upload before proceeding with this new eSubmission.
                                            </p>
                                            <p>
                                                Scan files must meet the following criteria:
                                            </p>
                                            <ul>
                                                <li>
                                                    Acceptable file formats are pdf, jpg, jpeg and png
                                                </li>
                                                <li>
                                                    Maximum allowable size for each attachment is up to 5MB
                                                </li>
                                            </ul>
                                            <p>
                                                Please note that you must keep the original tax invoice(s)/receipt(s) for at least 6 months from claim submission date and must be made readily available upon Insurer's request. Please ensure your email address and handphone number updated in the e-claim portal are correct.
                                            </p>
                                            <p>
                                                When we pay an eligible claim, precedence shall be given in the following order:
                                            </p>
                                            <ul>
                                                <li>
                                                    Employee if they have settled the eligible medical bills by cash
                                                </li>
                                                <li>
                                                    Medisave account as indicated in the tax invoices or bills
                                                </li>
                                                <li>
                                                    Patient's Medisave-Approved Integrated Shield Plan or CPF Medishield Life (if applicable) in accordance with the CPF Act.
                                                </li>
                                            </ul>
                                        </Message>
                                    </Grid.Column>

                                    <Grid.Column width={16}>    
                                        {/* TAX INVOICE RECEIPT DOCUMENT */}
                                        <Fragment>
                                            You may upload more than {this.props.configBenefit.featuresConfig.maximumFileUpload} tax invoice/receipt:
                                            
                                            <DropzoneComponent
                                                config={componentConfig}
                                                eventHandlers={
                                                    {
                                                        maxfilesexceeded: (file) => {
                                                            console.log("maxfilesexceeded ", this.props.configBenefit.featuresConfig.maximumFileUpload)
                                                            const maxUpload = this.props.configBenefit && this.props.configBenefit.featuresConfig.maximumFileUpload 
                                                            ? this.props.configBenefit.featuresConfig.maximumFileUpload
                                                            : 5
                                                            
                                                            alert(`You can only upload up to ${ maxUpload } files!`);
                                                            this.removeFile(file);
                                                            file.previewElement.remove(); // Remove the extra file from the UI
                                                        },
                                                        addedfile: (file) => {
                                                            // console.log(file);
                                                            console.log("addedfile ", this.state.files)
                                                            if(this.state.files.filter(f => f.upload.is_invoice_receipt == true).length >= 5){
                                                                // alert(`You can only upload up to 5 files!`);
                                                                this.removeFile(file)
                                                                return;
                                                            }
                                                            if (file.type.includes('jpeg')||
                                                                file.type.includes('jpg')||
                                                                file.type.includes('png')||
                                                                file.type.includes('pdf')||
                                                                file.type.includes('heif')||
                                                                file.type.includes('heic')){
                                                                    this.updateFileTest(file, true);
                                                                } else {
                                                                    this.setState({error:true,errorMessage:'Only image file (jpeg, jpg, png) and PDF file are allowed.'})
                                                                }
                                                        },
                                                        removedfile: (file) => {
                                                            this.removeFile(file);
                                                        }
                                                    }
                                                }
                                                djsConfig={{
                                                    ...djsConfig,
                                                    maxFiles: this.props.configBenefit.featuresConfig.maximumFileUpload
                                                    ? this.props.configBenefit.featuresConfig.maximumFileUpload
                                                    : 5
                                                }}
                                            />
                                            {this.checkAttachmentFile()}
                                            {
                                                (errors['uploadAttachmentsInv']) &&
                                                (
                                                    <Message negative>
                                                        {errors['uploadAttachmentsInv']}
                                                    </Message>
                                                )
                                            }
                                        </Fragment>

                                        <div style={{ height: 24 }}></div>

                                        {/* COMMON DOCUMENT */}
                                        <Fragment>
                                            You may upload more than {this.props.configBenefit.featuresConfig.maximumFileUpload} other supporting documents:
                                            <DropzoneComponent
                                                config={componentConfig}
                                                eventHandlers={
                                                    {
                                                        maxfilesexceeded: (file) => {
                                                            const maxUpload = this.props.configBenefit && this.props.configBenefit.featuresConfig.maximumFileUpload 
                                                            ? this.props.configBenefit.featuresConfig.maximumFileUpload
                                                            : 5
                                                            
                                                            alert(`You can only upload up to ${ maxUpload } files!`);
                                                            this.removeFile(file);
                                                            file.previewElement.remove(); // Remove the extra file from the UI
                                                        },
                                                        addedfile: (file) => {
                                                            // console.log(file);
                                                            console.log("addedfile ", this.state.files)
                                                            if(this.state.files.filter(f =>  f.upload.is_invoice_receipt == false).length >= 5){
                                                                this.removeFile(file);
                                                                // alert(`You can only upload up to 5 files!`);
                                                                return;
                                                            }
                                                            if (file.type.includes('jpeg')||
                                                                file.type.includes('jpg')||
                                                                file.type.includes('png')||
                                                                file.type.includes('pdf')||
                                                                file.type.includes('heif')||
                                                                file.type.includes('heic')){
                                                                    this.updateFileTest(file);
                                                                } else {
                                                                    this.setState({error:true,errorMessage:'Only image file (jpeg, jpg, png) and PDF file are allowed.'})
                                                                }
                                                        },
                                                        removedfile: (file) => {
                                                            this.removeFile(file);
                                                        }
                                                    }
                                                }
                                                djsConfig={{
                                                    ...djsConfig,
                                                    maxFiles: this.props.configBenefit.featuresConfig.maximumFileUpload
                                                    ? this.props.configBenefit.featuresConfig.maximumFileUpload
                                                    : 5
                                                }}
                                            />
                                            {this.checkAttachmentFile()}
                                            {
                                                (errors['uploadAttachments']) &&
                                                (
                                                    <Message negative>
                                                        {errors['uploadAttachments']}
                                                    </Message>
                                                )
                                            }
                                        </Fragment>           
                                    </Grid.Column>
                                    <Grid.Column width={16}>
                                        {this.renderClaimSubmissionResult()}
                                    </Grid.Column>
                                    <Grid.Column width={16}>
                                        <Button
                                            loading={isSubmitting}
                                            type="submit"
                                            primary
                                            disabled={isSubmitting}
                                            fluid
                                            size="big"
                                        >
                                            Next
                                        </Button>
                                    </Grid.Column>
                                </Grid>
                            </Form>
                        )}
                    />
                }
            </div>
        );
    }
}

export default FormsClaimOutpatient;
